import DEFINE, { PATHS } from './../constants/Define';

export default [{
    title: "vinWonders",
    tagSub: "vinWonders",
    exact: false,
    path: PATHS.VIN_WONDER.path,
    show: true,
    icon: "tag",
    isParrentMenu: true,
    routeName: DEFINE.GENERAL.ROUTE_NAME.VIN_WONDERS,
    permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
    children: [
        {
            title: "vinWonders",
            group: "vinWonders",
            tagSub: "vinWonders",
            path: PATHS.VIN_WONDER.LIST.path,
            exact: false,
            icon: 'tags',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.VIN_WONDERS,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE,
                DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE
            ],
            children: [
                {
                    title: "createVinWonder",
                    group: "vinWonders",
                    tagSub: "vinWonders",
                    path: PATHS.VIN_WONDER.CREATE.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                }, {
                    title: "updateVinWonder",
                    group: "vinWonders",
                    tagSub: "vinWonders",
                    path: PATHS.VIN_WONDER.DETAIL.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                }
            ]
        },
        {
            title: "vinWonderPrice",
            group: "vinWonderPrice",
            tagSub: "vinWonders",
            path: PATHS.VIN_WONDER_PRICE.LIST.path,
            exact: false,
            icon: 'tags',
            show: false,
            routeName: DEFINE.GENERAL.ROUTE_NAME.VIN_WONDER_PRICE,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE,
                DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE
            ],
            children: [
                {
                    title: "createVinWonder",
                    group: "vinWonders",
                    tagSub: "vinWonders",
                    path: PATHS.VIN_WONDER_PRICE.CREATE.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                }, {
                    title: "updateVinWonder",
                    group: "vinWonders",
                    tagSub: "vinWonders",
                    path: PATHS.VIN_WONDER_PRICE.DETAIL.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                }
            ]
        },
        {
            title: "vinWonderTickets",
            group: "vinWonderTickets",
            tagSub: "vinWonders",
            path: PATHS.VIN_WONDER_TICKET.LIST.path,
            exact: false,
            icon: 'tags',
            show: false,
            routeName: DEFINE.GENERAL.ROUTE_NAME.VIN_WONDER_TICKET,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE,
                DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE
            ],
            children: [
                {
                    title: "createVinWonder",
                    group: "vinWonders",
                    tagSub: "vinWonders",
                    path: PATHS.VIN_WONDER_TICKET.CREATE.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                }, {
                    title: "updateVinWonder",
                    group: "vinWonders",
                    tagSub: "vinWonders",
                    path: PATHS.VIN_WONDER_TICKET.DETAIL.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                }
            ]
        },
        {
            title: "checkVinWonder",
            group: "checkVinWonder",
            tagSub: "vinWonders",
            path: PATHS.VIN_WONDER.CHECK.path,
            exact: false,
            icon: 'check',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.VIN_WONDER_TICKET,
            permissions: [DEFINE.GENERAL.PERMISSION.CHECK],
        },
    ]
}]